import React, { useState } from "react";
// import styled from "@emotion/styled";
import styled from "styled-components";

import { capitalize } from "@formant/core/common/capitalize";
import { AnalyticsChartType } from "@formant/core/model/AnalyticsChartType";
import { analyicsChartTypes } from "@formant/core/model/analyticsChartTypes";
import { primary } from "@formant/ui/component/common/Colors";
import { IconName } from "@formant/ui/component/common/Icon";

import { MenuItem } from "../../common/Menu/MenuItem";
import { MenuItemGroup } from "../../common/Menu/MenuItemGroup";

interface IChartSelectorProps {
    chartType: AnalyticsChartType;
    onSelectChart: (chartType: AnalyticsChartType) => void;
}

export function ChartSelector(props: IChartSelectorProps) {
    const { chartType, onSelectChart } = props;

    const [hovered, setHovered] = useState<AnalyticsChartType | undefined>();

    const chartToIconsMap: Record<AnalyticsChartType, IconName> = {
        line: "line",
        bar: "bar",
        table: "table",
        pie: "pie",
        summary: "summary",
        scatter: "scatter",
        json: "json",
    };

    return (
        <div onMouseLeave={() => setHovered(undefined)}>
            <MenuGroup>
                {analyicsChartTypes.map(_ => (
                    <Item
                        key={_}
                        value={_}
                        label={capitalize(_)}
                        icon={chartToIconsMap[_ || "line"]}
                        hovered={hovered === _ || chartType === _}
                        selected={chartType === _}
                        onHover={value => setHovered(value || chartType)}
                        onSelected={() => onSelectChart(_)}
                        hoverClass="hovered"
                    />
                ))}
            </MenuGroup>
        </div>
    );
}

const Item = styled(MenuItem<AnalyticsChartType, string>)``;

const MenuGroup = styled(MenuItemGroup)`
    &&& {
        border: 0.0625rem solid ${primary.steel02};
        background-color: ${primary.steel01};
        border-radius: 0.25rem;

        ${Item} {
            padding-top: 1.1rem;
            padding-bottom: 1.1rem;
            color: ${primary.silver};
        }

        ${Item}:first-of-type {
            border-top-right-radius: 0.25rem;
            border-top-left-radius: 0.25rem;
        }

        ${Item}:last-of-type {
            border-bottom-right-radius: 0.25rem;
            border-bottom-left-radius: 0.25rem;
        }

        .hovered {
            background: ${primary.steel03};
            svg {
                color: ${primary.white};
            }
        }
    }
`;
